import AppUpdateNotificationPopup from '@/AppUpdateNotificationPopup'
import useFirstTimeAppRender from '@/components/useFirstTimeAppRender'
import FirstTimeAppNoticePopup from '@/pages/FirstTimeAppNoticePopup'
import { useState } from 'react'

export default function DashboardDialogs() {
    const [showUpdateNotificationOverride, set_showUpdateNotificationOverride] = useState(false)

    const {
        isUpdateAvailable,
        showUpdateNotification,
        showAppstartNotification,
        closeUpdateNotification,
        set_showAppstartNotification,
        runAppUpdate,
    } = useFirstTimeAppRender()

    return (
        <>
            {(showUpdateNotification || showUpdateNotificationOverride) && isUpdateAvailable && (
                <AppUpdateNotificationPopup
                    versionData={isUpdateAvailable}
                    onClose={(affirmative: boolean, dontAskAgainForThisVersion: boolean) => {
                        if (affirmative) {
                            runAppUpdate()
                        }
                        closeUpdateNotification({ dontAskAgainForThisVersion })
                        set_showUpdateNotificationOverride(false)
                    }}
                />
            )}

            {showAppstartNotification && (
                <FirstTimeAppNoticePopup onClose={() => set_showAppstartNotification(false)} />
            )}
        </>
    )
}
